import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FlagsService } from '@uigy/shared/services/flags.service';
import { DefaultPathService } from '@uigy/shared/services/default-path.service';

@Component({
    selector: 'app-reload',
    template: '',
    standalone: false
})
export class ReloadComponent {
  constructor(private router: Router,
              private defaultPathService: DefaultPathService,
              private flagsService: FlagsService,
  ) {
    this.flagsService.renewFlagsSubscription();
    this.router.navigate(this.defaultPathService.getDefaultPathParts);
  }
}
